<template>
    <div>
        <!-- Modal Laudo Usuario -->
        <div class="modal fade" id="laudoOcorrenciaLoteModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog modal-xl modal-dialog-scrollable" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Registrar Ocorrência</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="row mb-3" v-if="novo_contato">
                            <div class="col col-12">
                                <az-input
                                    :validate="validate"
                                    type="select" 
                                    optionsMode="aql"
                                    service="contato_status.index"
                                    :optionsParm="{ model: 'laudo', ativos: true }"
                                    :optionsName="'cont_status_laudo'"
                                    optionsData="id_contato_status"
                                    placeholder="Selecione..."
                                    v-model="novo_contato.id_contato_status" />

                                <template v-if="!!novo_contato.id_contato_status">
                                    <az-input
                                        required 
                                        :validate="validate"
                                        label="Comentários"
                                        type="textarea"
                                        rows="3"
                                        v-model="novo_contato.st_observacoes" />

                                    <az-input
                                        v-if="status_selecionado && status_selecionado.fl_informar_data"
                                        required 
                                        :validate="validate"
                                        label="Referência"
                                        type="date"
                                        v-model="novo_contato.dt_referencia" />
                                </template>
                            </div>
                        </div>

                        <template v-if="laudo || lista">
                            <!-- Definir para vários laudos -->
                            <div v-if="lista">
                                <table class="table table-sm table-hover small">
                                    <thead>
                                        <tr>
                                            <th>
                                                <a href="#" @click.prevent="marcar_todos()">
                                                    <i class="fa-solid fa-square"></i>
                                                </a>
                                            </th>
                                            <th>Paciente</th>
                                            <th>#</th>
                                            <th>Procedimento</th>
                                            <th>Material</th>
                                            <th>Responsáveis</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(item, iix) in lista" :key="iix">
                                            <td>
                                                <input type="checkbox" v-model="item.selec" /> 
                                            </td>
                                            <td>
                                                {{ item.atendimento_procedimento.atendimento.paciente.st_nome }}
                                            </td>
                                            <td>
                                                #{{ item.atendimento_procedimento.id_atendimento }}
                                            </td>
                                            <td>
                                                {{ item.atendimento_procedimento.procedimento.search }}
                                            </td>
                                            <td>
                                                <span v-if="item.atendimento_procedimento.amostra">
                                                    {{ item.atendimento_procedimento.amostra.search }}
                                                    <template v-if="item.atendimento_procedimento.amostra.js_classes && item.atendimento_procedimento.amostra.js_classes.length">
                                                        <span class="badge badge-success ml-1" v-for="(classe, icx) in item.atendimento_procedimento.amostra.js_classes" :key="icx">
                                                            {{ classe }}
                                                        </span>
                                                    </template>
                                                </span>
                                            </td>
                                            <td>
                                                {{ lista_resps(item) }}
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>

                            <!-- Definir para um laudo -->
                             <template v-else-if="laudo">
                                <div class="alert alert-info">
                                    <celula-dados-paciente :hor="dados_paciente(laudo)" />
                                    <hr>
                                    <div>
                                        {{ laudo.atendimento_procedimento.procedimento.search }}
                                    </div>
                                    <div class="small">
                                        #{{ laudo.atendimento_procedimento.id_atendimento }}
                                    </div>
                                </div>
                            </template>
                        </template>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                        <az-submit @click="atualizar()">Incluir</az-submit>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import $ from 'jquery';
import _ from 'lodash';
import CelulaDadosPaciente from "../../shared/table/CelulaDadosPaciente.vue";
//import AzEmptyState from '../../util/AzEmptyState.vue';
import AzInput from '../../shared/forms/AzInput.vue';
import AzSubmit from '../../util/AzSubmit.vue';

export default {
    components: {
        CelulaDadosPaciente,
        //AzEmptyState,
        AzInput,
        AzSubmit
    },

    data() {
        return { 
            laudo: null, 
            validate: false, 
            lista: null, 
            para_substituir: false, 
            novo_contato: null, 
        }
    },

    props: ['fila'],

    computed: { 
        selecionados: function () { 
            if ( !this.lista || !this.lista.length ) {
                return [];
            }

            return this.lista.filter(item => item.selec);
        },

        tem_responsavel: function () { 
            if ( this.selecionados.find(item => item.selec && this.lista_resps(item)) ) {
                return true;
            }

            return false; 
        }
    },

    methods: { 
        marcar_todos () { 
            let selec = this.lista.every(item => item.selec);

            this.lista.forEach(item => { 
                item.selec = !selec;
            });
        },

        lista_resps (laudo) { 
            let lista = [];

            if ( laudo && laudo.resps && laudo.resps.length ) { 
                lista = laudo.resps.filter(item => item.fl_ativo)
                    .map(item => item.usuario ? item.usuario.st_login : '---' );
            }

            return lista.join(', ');
        },

        incluir_resp () { 
            this.laudo.resps.push({ 
                id_laudo_usuario: null, 
                id_usuario: null,
                usuario: null,
                fl_ativo: 1, 
                id_laudo: this.laudo.id_laudo,
                st_obs: null, 
            });
        },

        abrir (laudo) { 
            this.lista = null; 
            this.validate = false; 
            this.laudo = _.cloneDeep(laudo);
            this.para_substituir = false; 

            this.novo_contato = { 
                id_contato_status: null, 
                st_observacoes: null, 
                dt_referencia: null, 
            };

            $('#laudoOcorrenciaLoteModal').modal('show');
        },

        abrir_lista (lista) { 
            this.validate = false; 
            this.para_substituir = false; 
            this.laudo = null; 
            this.lista = _.cloneDeep(lista).map(l => { 
                l.selec = false; 
                return l;
            });

            this.novo_contato = { 
                id_contato_status: "", 
                st_observacoes: "", 
                dt_referencia: null, 
            };
            
            $('#laudoOcorrenciaLoteModal').modal('show');
        },

        atualizar () { 

            if ( this.lista ) { 
                if ( !this.selecionados.length ) { 
                    this.$toast.add({
                        severity: 'warn',
                        summary: 'Atenção',
                        detail: 'Nenhum laudo selecionado para atualizar os responsáveis.',
                        life: 5000
                    });
                    return;
                }
            }

            this.$util.atualizar(this, { 
                service: 'laudos',
                func: 'salvar_ocorrencias',
                dados: { 
                    em_bloco: this.lista ? true : false,
                    selecionados: this.selecionados.map(item => item.id_laudo),
                    info_contato: this.novo_contato,
                }, 
                modal: 'laudoOcorrenciaLoteModal',
                toast: true, 
                callback: () => {
                    this.$emit('refresh');
                }
            });
        },

        dados_paciente(laudo) {
            return {
                marcacao: {
                    plano: laudo.atendimento_procedimento.atendimento.plano,
                    paciente: laudo.atendimento_procedimento.atendimento.paciente,
                    fl_preferencial: laudo.atendimento_procedimento.atendimento.marcacao
                        ? laudo.atendimento_procedimento.atendimento.marcacao.fl_preferencial
                        : false,
                }
            };
        },
    }
}
</script>
